import axios from "axios";
import { logger } from "../logger";
export const ENDPOINT = `${process.env.NEXT_PUBLIC_API || 'https://api.axelgodefroy.fr'}`;
export const STRAPI = `${process.env.NEXT_PUBLIC_STRAPI || 'https://api.axelgodefroy.fr'}`;
/**
 * @param {String|Object<endpoint:String,path:String>} url  URL to request
 * @param {String} [method] HTTP Method by default GET
 * @param {String} [returnValue] string evaluated to get specific value from axios request
 * @returns {Promise}
 */
export const request = (
  url,
  method = "get",
  options,
  returnValue = "res.data.data"
) => {
  return new Promise(async (resolve, rej) => {
    try {
      let path;
      if (typeof url == "string") path = ENDPOINT + url;
      else path = url.endpoint + url.path;
      let res = await axios[method](path, options);
      logger.succes(`${res.status} ${res.statusText}`, `${res.config.url}`);

      resolve(eval(returnValue));
    } catch (err) {
      if (err.response)
        logger.error(
          `ERROR ${err.response.status}`,
          `${err.response.data.message} (${err.response.config.url})`
        );
      else if (err.message == "Network Error") {
        logger.error(`ERROR CORS`, `${err.message} (${url})`);
      } else console.error(err);
      rej(err);
    }
  });
};

/**
 * @param {String|Object<endpoint:String,path:String>} url  URL to request
 * @param {String} [method] HTTP Method by default GET
 * @param {String} [returnValue] string evaluated to get specific value from axios request
 * @returns {Promise}
 */
export const requestStrapi = (
  url,
  method = "get",
  options,
  returnValue = "res.data.data"
) => {
  return new Promise(async (resolve, rej) => {
    try {
      let path;
      if (typeof url == "string") path = STRAPI + "/api" + url;
      else path = url.endpoint + url.path;
      let res = await axios[method](path, options);
      logger.succes(`${res.status} ${res.statusText}`, `${res.config.url}`);
      resolve(eval(returnValue));
    } catch (err) {
      if (err.response)
        logger.error(
          `ERROR ${err.response.status}`,
          `${err.response.data.message} (${err.response.config.url})`
        );
      else if (err.message == "Network Error") {
        logger.error(`ERROR CORS`, `${err.message} (${url})`);
      } else console.error(err);
      rej(err);
    }
  });
};
